import { Bar } from 'react-chartjs-2';

import { baseBarOptions } from './chartOptions.js';
import './registerCharts.js';
import { useChartPalette } from './useChartPalette.js';

/**
 * @param {{ labels: string[], datasets: Array<{label:string,data:number[],color:string}>, stacked?: boolean, height?: number, valueKind?: 'count'|'currency' }} props
 */
export function BarChart({ labels, datasets, stacked = false, height = 280, valueKind }) {
  const palette = useChartPalette();
  const data = {
    labels,
    datasets: datasets.map((d) => ({
      label: d.label,
      data: d.data,
      backgroundColor: d.color,
      borderRadius: 3,
      maxBarThickness: 42,
    })),
  };
  return (
    <div style={{ height }}>
      <Bar data={data} options={baseBarOptions(palette || {}, { stacked, valueKind })} />
    </div>
  );
}
